import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, X, ListChecks } from "lucide-react";
import { api } from "@/lib/api";

export default function Checklist({ leagueId }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/leagues/${leagueId}/checklist`).then(({ data }) => setD(data)).catch(() => setD(null)); }, [leagueId]);
  if (!d || d.hidden || d.done === d.total) return null;
  const hide = () => { api.post(`/leagues/${leagueId}/checklist/hide`); setD({ ...d, hidden: true }); };
  return (
    <section className="mpl-card mpl-rise p-5" data-testid="onboarding-checklist">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="mpl-eyebrow flex items-center gap-1.5 text-[#B7F52A]"><ListChecks size={13} /> Bien démarrer</p>
          <p className="mt-1 font-display text-2xl font-extrabold uppercase leading-none">{d.done}/{d.total} étapes</p>
        </div>
        <button onClick={hide} className="text-slate-500 hover:text-white" aria-label="Masquer" data-testid="checklist-hide"><X size={16} /></button>
      </div>
      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-white/10"><div className="h-full rounded-full bg-[#B7F52A] transition-[width] duration-700" style={{ width: `${(d.done / d.total) * 100}%` }} data-testid="checklist-progress" /></div>
      <ol className="mt-4 space-y-2">{d.steps.map((s) => (
        <li key={s.key} data-testid={`checklist-step-${s.key}`}>
          <Link to={s.link} className={`flex items-center gap-3 rounded-xl border p-3 transition-colors ${s.done ? "border-[#B7F52A]/20 bg-[#B7F52A]/[0.05]" : "border-white/10 hover:border-[#B7F52A]/50"}`}>
            <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${s.done ? "bg-[#B7F52A] text-[#101310]" : "border border-white/20"}`}>{s.done && <Check size={13} strokeWidth={3} />}</span>
            <span className="min-w-0"><span className={`block text-sm font-semibold ${s.done ? "text-slate-400 line-through" : "text-white"}`}>{s.label}</span>
              {!s.done && <span className="block text-xs text-slate-400">{s.hint}</span>}</span>
          </Link>
        </li>))}</ol>
    </section>
  );
}
